import { ShopAddress } from './types';

export function formatAddress(address: ShopAddress): string {
  return `${address.street}, ${address.city}, ${address.state} ${address.zip}`;
}

export function getGoogleMapsUrl(address: ShopAddress): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    formatAddress(address)
  )}`;
}

export function getAppleMapsUrl(address: ShopAddress): string {
  return `https://maps.apple.com/?q=${encodeURIComponent(formatAddress(address))}`;
}
